import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    searchList: [],
    searchListCount: 0,
    searchListMax : 0,
    nombre: '',

    searchResults: [],
    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
};

const mutations = {
    updateField,

    'INICIALIZAR_SEARCH' (state, params) {
        state.searchList = [];
        state.searchListCount = 0;
        state.searchListMax = 0;
        state.nombre = params.nombre;
    },
    'SET_SEARCH' (state, results) {
        state.searchList = results.results.map(searchItem => ({
            ...searchItem,
            uuId: getUUID()
        }));
        state.searchListCount = results.totalRegistros;
        state.searchListMax = results.maxRegistros;

        state.searchResults = [];
        state.paginaActual = 1;
        state.totalRegistros = 0;
        state.totalPaginas = 0;
    },
    'CLEAR' (state) {
        state.searchList = [];
        state.nombre = '';

        state.searchResults = [];
        state.paginaActual = 1;
        state.totalRegistros = 0;
        state.totalPaginas = 0;
    },

    'INICIALIZAR_SEARCH_RESULTS' (state) {
        state.searchResults = [];
    },
    'SET_SEARCH_RESULTS' (state, searchResults) {
        state.searchResults = searchResults;
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },
};

function getUUID(){
    var dt = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (dt + Math.random()*16)%16 | 0;
        dt = Math.floor(dt/16);
        return (c=='x' ? r :(r&0x3|0x8)).toString(16);
    });
    return uuid;
}

const getters = {
    getField,

    searchList (state) {
        return state.searchList;
    }
};

const actions = {
    getSearchList ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_SEARCH', params);

            let queryString = '?nombre='+ params.nombre;
            
            apiAxios.get('utilities' + queryString)
                .then(res => {
                    commit('SET_SEARCH', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    clear( { commit }) {
        commit('CLEAR');
    },

    getSearchResults ( { commit, state } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_SEARCH_RESULTS');

            if (state.nombre.trim() != '') {
                let queryString = '?pageSize=' + state.registrosPorPagina
                    + '&pageNumber=' + state.paginaActual
                    + '&nombre=' + state.nombre;
               
                apiAxios.get('utilities/resultados' + queryString)
                    .then(res => {
                        if (res.headers.pagination){
                            const pagination= JSON.parse(res.headers.pagination)
                            var params = {
                                paginaActual: pagination.currentPage,
                                registrosPorPagina: pagination.itemsPerPage,
                                totalRegistros: pagination.totalItems,
                                totalPaginas: pagination.totalPages,
                            }    
                            commit('SET_PAGINATION', params);
                        }
                        commit('SET_SEARCH_RESULTS', res.data);
    
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })
    },

};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}